import React from 'react';

import { Section } from 'jbc-front/components/Form';
import { getOptionLabel, numToStr, display, currency } from 'src/utils/Utils';
import DefaultValue from './DefaultValue';
import CommutingByCarShow from '../containers/CommutingByCarShowContainer';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const CommutingByTrainShow = ({ commutingItem }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Section title={t('features.Employees.components.CommutingsSection.Train')}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.entraining_station')}：</th>
              <td>{display(commutingItem.firstStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.arrival_station')}：</th>
              <td>{display(commutingItem.lastStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.transit_point')}：</th>
              <td>{display(commutingItem.middleStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.one_way_fare')}：</th>
              <td>{currency(numToStr(commutingItem.oneWayFare))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.commuting_pass_fee')}：</th>
              <td>{currency(numToStr(commutingItem.paymentAmount))}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  );
};

const CommutingByBusShow = ({ commutingItem }) => {
  const{ t } = useTranslation();
  return (
    <div>
      <Section title={t('features.Employees.components.CommutingsSection.Bus')}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.boarding_stop')}：</th>
              <td>{display(commutingItem.firstStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.drop_off_stop')}：</th>
              <td>{display(commutingItem.lastStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.transit_point')}：</th>
              <td>{display(commutingItem.middleStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.one_way_fare')}：</th>
              <td>{currency(numToStr(commutingItem.oneWayFare))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingsSection.commuting_pass_fee')}：</th>
              <td>{currency(numToStr(commutingItem.paymentAmount))}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  );
};

const CommutingItem = ({ commutingItem }) => (
  <div>
    {commutingItem.meansOfCommunication === 'train' && <CommutingByTrainShow {...{ commutingItem }} />}
    {commutingItem.meansOfCommunication === 'bus' && <CommutingByBusShow {...{ commutingItem }} />}
    {commutingItem.meansOfCommunication === 'car' && <CommutingByCarShow {...{ commutingItem }} />}
  </div>
);

const CommutingsSectionShow = ({
  employee,
  employeeCommutings,
  paymentDurationUnits,
  meansOfCommunications,
  paymentDurationTypes
}) => {
  const { t } = useTranslation();
  if (employee.meansOfCommunication)
    return (
      <div>
        <div>
          <table className={tableStyles.mTablePersonal}>
            <tbody>
              <tr>
                <th>{t('features.Employees.components.CommutingsSection.payment_unit')}：</th>
                <td>{display(getOptionLabel(employee.paymentDurationUnit)(paymentDurationUnits))}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.CommutingsSectionShow.payment_month')}</th>
                <td>{display(getOptionLabel(employee.paymentDurationType)(paymentDurationTypes))}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.InsertBatchCsv.commuting_method')}：</th>
                <td>{display(getOptionLabel(employee.meansOfCommunication)(meansOfCommunications))}</td>
              </tr>
              {employee.meansOfCommunication !== 'walking' && (
                <tr>
                  <th>{t('features.Employees.components.CommutingsSectionShow.total_payment_amount')}</th>
                  <td>
                    <span>{currency(display(numToStr(employee.totalCommutingFee)))}</span>
                    {employee.paymentDurationUnit === 'per_working_days' && <span>×労働日数</span>}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {employee.meansOfCommunication !== 'walking' && (
            <div className="u-mt30">
              {employeeCommutings.map(item => <CommutingItem commutingItem={item} key={item.id} />)}
            </div>
          )}
        </div>
      </div>
    );
  return <DefaultValue />;
};

export default CommutingsSectionShow;
